'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrandClassNameAndStyle = exports.getGradientClassName = undefined;
exports.buildColorRecord = buildColorRecord;

var _textColorUtils = require('ui-addon-conversations/utils/textColorUtils');

var _BaseBrandColors = require('conversations-schema/constants/BaseBrandColors');

var _ColoringRecord = require('conversations-schema/records/ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getGradientClassName = exports.getGradientClassName = function getGradientClassName(color) {
  switch (color) {
    case _BaseBrandColors.FIRST_COLOR:
      return 'brand-color-element first';
    case _BaseBrandColors.SECOND_COLOR:
      return 'brand-color-element second';
    case _BaseBrandColors.THIRD_COLOR:
      return 'brand-color-element third';
    case _BaseBrandColors.FOURTH_COLOR:
      return 'brand-color-element fourth';
    case _BaseBrandColors.FIFTH_COLOR:
      return 'brand-color-element fifth';
    default:
      return '';
  }
};

var getBrandClassNameAndStyle = exports.getBrandClassNameAndStyle = function getBrandClassNameAndStyle(accentColor, elementClassName) {
  var gradientClassName = getGradientClassName(accentColor);
  var className = elementClassName + ' ' + gradientClassName;
  var style = gradientClassName ? null : { backgroundColor: accentColor };

  return {
    className: className,
    style: style
  };
};

function buildColorRecord(accentColor) {
  if (accentColor == null) {
    return new _ColoringRecord2.default();
  }

  return new _ColoringRecord2.default({
    accentColor: accentColor,
    textColor: (0, _textColorUtils.getTextColor)(accentColor),
    useDefaultColor: (0, _textColorUtils.useDefaultElementColor)(accentColor)
  });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/util/color.js
// module id = 163
// module chunks = 2 3